import classNames from "classnames";

function Navbar({ children, className }) {
  return (
    <nav className="navbar">
      <div className={classNames("navbar-container my-3", className)}>{children}</div>
    </nav>
  );
}

export default Navbar;
